

import { Component, Prop, Vue } from "vue-property-decorator"

/**
 * A text input for searching, with a clear (×) button that appears once it has
 * a value. v-model compatible (value prop + input event). Any extra attributes
 * (e.g. data-cy) fall through to the underlying input.
 */
@Component({
	inheritAttrs: false
})
export default class SearchInput extends Vue {
	@Prop({ type: String, default: "" })
	value!: string;

	@Prop({ type: String, default: "Search" })
	placeholder!: string;

	public get search (): string {
		return this.value
	}

	public set search (value: string) {
		this.$emit("input", value)
	}

	public clear () {
		this.$emit("input", "")
		this.focus()
	}

	public focus () {
		const input = this.$refs.input as any
		if (input && typeof input.focus === "function") input.focus()
	}
}

